"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.21.0
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { clsx } from 'clsx';
import { SvgIcon } from '../SvgIcon/index.mjs';
import { SvgIconType } from '../SvgIcon/svg-icon-type.mjs';
import { Truncate } from '../Truncate/index.mjs';
import { dropdownRecipe } from '../../recipes/dropdown.mjs';

const NoOptionsHeading = forwardRef(({ className, text, ...props }, ref) => {
  const styles = dropdownRecipe();
  return /* @__PURE__ */ jsxs("span", { role: "heading", "aria-level": 2, className: clsx(styles["no-options-heading"], className), ...props, ref, children: [
    /* @__PURE__ */ jsx(SvgIcon, { type: SvgIconType.ZoomCancel, className: styles["no-options-heading-icon"] }),
    /* @__PURE__ */ jsx(Truncate, { children: text })
  ] });
});

export { NoOptionsHeading };
